import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import { Observable, map, switchMap } from "rxjs";
import { environments } from 'src/environments/environment';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

    activeAccount: AccountInfo | undefined;

    constructor(
        private authService: MsalService) {
        this.activeAccount = this.authService.instance.getAllAccounts()[0];
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const username = environments.USER_ENV_NOT_PDN;
                        const password = environments.PASS_ENV_NOT_PDN;
                        const authHeader = 'Basic '+btoa(username+':'+password);
    
                        const respuesta = req.clone({
                            setHeaders: {
                                'content-type': 'application/json',
                                'Authorization': authHeader
                            }
                        });
                        return next.handle(respuesta);
            
    }

}